import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoggedRoutingModule } from './logged-routing.module';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { StrumentiUtiliComponent } from './dashboard/strumenti-utili/strumenti-utili.component';

@NgModule({
  declarations: [DashboardComponent, StrumentiUtiliComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    LoggedRoutingModule,
  ],
})
export class LoggedModule {}
